// Generated by `bazel run i18n`. Do not edit by hand.
import shipping_335970ed from "./en/conversion--src--checkouts--shipping.json";
import fields_fd965d1a from "./en/conversion--src--conversion--hsa--fields.json";
import hsa_ac3ac510 from "./en/conversion--src--conversion--hsa.json";
import common_d6eeb961 from "./en/email-builder--src--email-builder--builder--inspectors--common.json";
import inspectors_0226aca6 from "./en/email-builder--src--email-builder--builder--inspectors.json";
import inspectors_add319a0 from "./en/marketing--src--marketing--loyalty-page-builder--builder--inspectors.json";
import support_183aa0c1 from "./en/merchant--support--app--src--analytics--dashboards--support.json";
import gmail_973b3089 from "./en/merchant--support--app--src--gmail.json";
import todos_399e4c2c from "./en/merchant--support--app--src--home-dashboard--todos.json";
import homeDashboard_275b66ae from "./en/merchant--support--app--src--home-dashboard.json";
import richpanel_5f6ac0c0 from "./en/merchant--support--app--src--richpanel.json";
import channel_c69c20ad from "./en/merchant--support--app--src--setting--channel.json";
import chatFlow_6005f791 from "./en/merchant--support--app--src--setting--chat-flow.json";
import customEmailGuide_2a97df0d from "./en/merchant--support--app--src--setting--custom-email-guide.json";
import components_35766d51 from "./en/merchant--support--app--src--setting--general--components.json";
import general_06e2964d from "./en/merchant--support--app--src--setting--general.json";
import components_322b0304 from "./en/merchant--support--app--src--setting--rules--components.json";
import conditions_b9c7f5d8 from "./en/merchant--support--app--src--setting--rules--conditions.json";
import actions_8f1b7308 from "./en/merchant--support--app--src--setting--rules--flow-editor--actions.json";
import conditions_76993dc2 from "./en/merchant--support--app--src--setting--rules--flow-editor--conditions.json";
import flowEditor_b2c7fbec from "./en/merchant--support--app--src--setting--rules--flow-editor.json";
import rules_79c4ca4e from "./en/merchant--support--app--src--setting--rules.json";
import setting_c5f4fbb6 from "./en/merchant--support--app--src--setting.json";
import messageTypes_90b42c61 from "./en/merchant--support--app--src--v2--components--message-types.json";
import rulesTriggered_7a174e58 from "./en/merchant--support--app--src--v2--components--timeline--events--rules-triggered.json";
import components_997f77e2 from "./en/merchant--support--app--src--v2--components.json";
import filters_1a56675f from "./en/merchant--support--app--src--v2--filters.json";
import hooks_895dc341 from "./en/merchant--support--app--src--v2--hooks.json";
import macros_b5fbeea2 from "./en/merchant--support--app--src--v2--setting--macros.json";
import topics_ac0f8735 from "./en/merchant--support--app--src--v2--setting--topics.json";
import views_12109ed6 from "./en/merchant--support--app--src--v2--views.json";
import voice_661e2dd9 from "./en/merchant--support--app--src--v2--voice.json";
import columns_54b84a38 from "./en/shipping-claims--src--shipping-claims--columns.json";
import filters_f12ab2b7 from "./en/shipping-claims--src--shipping-claims--filters.json";
import shippingClaims_61103820 from "./en/shipping-claims--src--shipping-claims.json";
import wishList_a317ffbf from "./en/src--accounts--wish-list.json";
import addressVerification_e12549c7 from "./en/src--address-verification.json";
import components_8788ffda from "./en/src--advanced-filters--components.json";
import inventoryConditions_0a39603f from "./en/src--advanced-filters--inventory-conditions.json";
import alert_cb4f06b8 from "./en/src--arbiter-components--alert.json";
import audio_54c5acfc from "./en/src--arbiter-components--audio.json";
import barComparison_dd9f407f from "./en/src--arbiter-components--bar-comparison.json";
import buttons_0f9b4c78 from "./en/src--arbiter-components--buttons.json";
import chartCard_ab36deeb from "./en/src--arbiter-components--charts--chart-card.json";
import funnelChart_3f108adf from "./en/src--arbiter-components--charts--funnel-chart.json";
import heatmap_5b3f06f8 from "./en/src--arbiter-components--charts--heatmap.json";
import inlineSparkline_6b3c6f9f from "./en/src--arbiter-components--charts--inline-sparkline.json";
import insightsBreakdown_433359b6 from "./en/src--arbiter-components--charts--insights-breakdown.json";
import lineAndBarChart_badd84c5 from "./en/src--arbiter-components--charts--line-and-bar-chart.json";
import sankeyChart_11f09e35 from "./en/src--arbiter-components--charts--sankey-chart.json";
import chat_43e0868a from "./en/src--arbiter-components--chat.json";
import colorPicker_dc2ecab5 from "./en/src--arbiter-components--color-picker.json";
import commandMenu_f7850140 from "./en/src--arbiter-components--command-menu.json";
import components_2004f0e8 from "./en/src--arbiter-components--date-picker--date-picker--components.json";
import datePicker_1b251895 from "./en/src--arbiter-components--date-picker.json";
import featureNotification_b995637d from "./en/src--arbiter-components--feature-notification.json";
import fileUpload_aba68c26 from "./en/src--arbiter-components--file-upload.json";
import filterGroup_d3af3fad from "./en/src--arbiter-components--filter-group.json";
import finder_ac36c95a from "./en/src--arbiter-components--finder.json";
import iconPicker_4cd52104 from "./en/src--arbiter-components--icon-picker.json";
import input_d46deba7 from "./en/src--arbiter-components--input.json";
import integrationsCard_4a8de999 from "./en/src--arbiter-components--integrations-card.json";
import list_f75b1116 from "./en/src--arbiter-components--list.json";
import metricItemTabs_ee4a670d from "./en/src--arbiter-components--metric-item-tabs.json";
import common_1e9ad8ea from "./en/src--arbiter-components--navigation--common.json";
import primary_8798fba8 from "./en/src--arbiter-components--navigation--primary.json";
import secondary_d7652588 from "./en/src--arbiter-components--navigation--secondary.json";
import navigation_7f15e9f5 from "./en/src--arbiter-components--navigation.json";
import notification_09fb707a from "./en/src--arbiter-components--notification.json";
import orderSummary_f6158015 from "./en/src--arbiter-components--order-summary.json";
import pageHeader_a9a3336c from "./en/src--arbiter-components--page-header.json";
import progressBar_2a923626 from "./en/src--arbiter-components--progress-bar.json";
import selectDropdown_564c4974 from "./en/src--arbiter-components--select-dropdown.json";
import settingsCard_e4a1d4cf from "./en/src--arbiter-components--settings-card.json";
import setupChecklist_7d28b589 from "./en/src--arbiter-components--setup-checklist.json";
import tables_390b9007 from "./en/src--arbiter-components--tables.json";
import tabs_b2632765 from "./en/src--arbiter-components--tabs.json";
import walkthrough_73189c2b from "./en/src--arbiter-components--walkthrough.json";
import arbiterComponents_3b80f7c1 from "./en/src--arbiter-components.json";
import carrier_9ceb052a from "./en/src--carrier.json";
import uiComponents_0de8e2a2 from "./en/src--concierge--ui-components.json";
import concierge_9889b48a from "./en/src--concierge.json";
import conversationDrawer_a24fe2c5 from "./en/src--conversation-drawer.json";
import header_77350453 from "./en/src--customer-widget--header.json";
import elevatedOnboarding_169c93f3 from "./en/src--elevated-onboarding.json";
import components_0e243925 from "./en/src--email-builder-shared--components.json";
import customerPortal_2b0b0374 from "./en/src--faq--customer-portal.json";
import filterOverflow_298f9622 from "./en/src--filter-overflow.json";
import filters_28bdf3d2 from "./en/src--filters.json";
import inspectors_06365bd1 from "./en/src--form-builder--inspectors.json";
import carrierForms_c5e15205 from "./en/src--fulfillment--setting--carrier-accounts--carrier-forms.json";
import carrierAccounts_5aac977c from "./en/src--fulfillment--setting--carrier-accounts.json";
import connectionTest_5773cd24 from "./en/src--integrations--connection-test.json";
import interactiveMap_4af1e6b7 from "./en/src--interactive-map.json";
import localizationGroups_8125c552 from "./en/src--localization-groups.json";
import merchantHomepage_84e5ef5d from "./en/src--merchant-homepage.json";
import oms_4073d763 from "./en/src--oms.json";
import onboarding_f4ee3d91 from "./en/src--onboarding.json";
import orderEditing_5dddfcc7 from "./en/src--order-editing.json";
import playbook_e6bdfebf from "./en/src--playbook.json";
import quill_a9953f9e from "./en/src--quill.json";
import reviewsForm_4a864350 from "./en/src--reviews-form.json";
import roles_77c717d1 from "./en/src--roles.json";
import order_b6f82b34 from "./en/src--settings-elements--order.json";
import settingsElements_b6a37e24 from "./en/src--settings-elements.json";
import exceptions_8c11dc43 from "./en/src--settings-rows--exceptions.json";
import settingsRows_fd1e47a5 from "./en/src--settings-rows.json";
import game_0094d47d from "./en/src--tracking-page-builder--blocks--game.json";
import productUpsell_809c17c2 from "./en/src--tracking-page-builder--blocks--product-upsell.json";
import trackingDetails_6eb31306 from "./en/src--tracking-page-builder--blocks--tracking-details.json";
import blocks_ff72bc2b from "./en/src--tracking-page-builder--blocks.json";
import inspectors_e75cf9d1 from "./en/src--tracking-page-builder--builder--inspectors.json";
import builder_d3c530f6 from "./en/src--tracking-page-builder--builder.json";
import trackingPageBuilder_187080c4 from "./en/src--tracking-page-builder.json";
import src_c1a2d0b5 from "./en/src.json";
import stories_8f166c96 from "./en/storybook--library--src--stories.json";

export default Object.assign(
  {},
  shipping_335970ed,
  fields_fd965d1a,
  hsa_ac3ac510,
  common_d6eeb961,
  inspectors_0226aca6,
  inspectors_add319a0,
  support_183aa0c1,
  gmail_973b3089,
  todos_399e4c2c,
  homeDashboard_275b66ae,
  richpanel_5f6ac0c0,
  channel_c69c20ad,
  chatFlow_6005f791,
  customEmailGuide_2a97df0d,
  components_35766d51,
  general_06e2964d,
  components_322b0304,
  conditions_b9c7f5d8,
  actions_8f1b7308,
  conditions_76993dc2,
  flowEditor_b2c7fbec,
  rules_79c4ca4e,
  setting_c5f4fbb6,
  messageTypes_90b42c61,
  rulesTriggered_7a174e58,
  components_997f77e2,
  filters_1a56675f,
  hooks_895dc341,
  macros_b5fbeea2,
  topics_ac0f8735,
  views_12109ed6,
  voice_661e2dd9,
  columns_54b84a38,
  filters_f12ab2b7,
  shippingClaims_61103820,
  wishList_a317ffbf,
  addressVerification_e12549c7,
  components_8788ffda,
  inventoryConditions_0a39603f,
  alert_cb4f06b8,
  audio_54c5acfc,
  barComparison_dd9f407f,
  buttons_0f9b4c78,
  chartCard_ab36deeb,
  funnelChart_3f108adf,
  heatmap_5b3f06f8,
  inlineSparkline_6b3c6f9f,
  insightsBreakdown_433359b6,
  lineAndBarChart_badd84c5,
  sankeyChart_11f09e35,
  chat_43e0868a,
  colorPicker_dc2ecab5,
  commandMenu_f7850140,
  components_2004f0e8,
  datePicker_1b251895,
  featureNotification_b995637d,
  fileUpload_aba68c26,
  filterGroup_d3af3fad,
  finder_ac36c95a,
  iconPicker_4cd52104,
  input_d46deba7,
  integrationsCard_4a8de999,
  list_f75b1116,
  metricItemTabs_ee4a670d,
  common_1e9ad8ea,
  primary_8798fba8,
  secondary_d7652588,
  navigation_7f15e9f5,
  notification_09fb707a,
  orderSummary_f6158015,
  pageHeader_a9a3336c,
  progressBar_2a923626,
  selectDropdown_564c4974,
  settingsCard_e4a1d4cf,
  setupChecklist_7d28b589,
  tables_390b9007,
  tabs_b2632765,
  walkthrough_73189c2b,
  arbiterComponents_3b80f7c1,
  carrier_9ceb052a,
  uiComponents_0de8e2a2,
  concierge_9889b48a,
  conversationDrawer_a24fe2c5,
  header_77350453,
  elevatedOnboarding_169c93f3,
  components_0e243925,
  customerPortal_2b0b0374,
  filterOverflow_298f9622,
  filters_28bdf3d2,
  inspectors_06365bd1,
  carrierForms_c5e15205,
  carrierAccounts_5aac977c,
  connectionTest_5773cd24,
  interactiveMap_4af1e6b7,
  localizationGroups_8125c552,
  merchantHomepage_84e5ef5d,
  oms_4073d763,
  onboarding_f4ee3d91,
  orderEditing_5dddfcc7,
  playbook_e6bdfebf,
  quill_a9953f9e,
  reviewsForm_4a864350,
  roles_77c717d1,
  order_b6f82b34,
  settingsElements_b6a37e24,
  exceptions_8c11dc43,
  settingsRows_fd1e47a5,
  game_0094d47d,
  productUpsell_809c17c2,
  trackingDetails_6eb31306,
  blocks_ff72bc2b,
  inspectors_e75cf9d1,
  builder_d3c530f6,
  trackingPageBuilder_187080c4,
  src_c1a2d0b5,
  stories_8f166c96,
);
